import { Component, Host, h, Method, State, Watch } from '@stencil/core';
import { getAuthState } from '../sy-site-auth/store/store';
import { getBaseURL } from '../../../env/enviroment';
import { SiteI18nConfig } from '../../models/i18n';
import { Consumes } from '@sydle/sydle-ui';

@Component({
  tag: 'sy-site-api',
  shadow: true,
})
export class SySiteApi {
  private apiUrl = getBaseURL();

  private getBearerToken() {
    if (!getAuthState('isAuthenticated')) return null;
    return `Bearer ${getAuthState('user') && getAuthState('user').token}`;
  }

  private waitForLanguageResolve;
  private waitForLanguage = new Promise(resolve => {
    this.waitForLanguageResolve = resolve;
  });

  @Consumes('i18next:language') @State() acceptLanguage: string;

  @Watch('acceptLanguage')
  acceptLanguageWatcher(): void {
    if (this.acceptLanguage) {
      this.waitForLanguageResolve();
    }
  }

  /**
   * Method to make a request do siteFacadeSYDLE on site-sydle application
   * @param path
   * @param body
   * @returns
   */
  @Method()
  async sendRequest(path: string, body: any, facade?: string): Promise<any> {
    const token = this.getBearerToken();
    facade = facade || 'siteFacadeSYDLE';
    return fetch(this.apiUrl + 'com.sydle.growth.marketing/' + facade + '/' + path, {
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
        ...(token && { authorization: token }),
        ...(this.acceptLanguage && { 'accept-language': this.acceptLanguage }),
      },
      body: JSON.stringify(body),
      method: 'POST',
    })
      .then(response => response.json())
      .catch(e => console.log(e));
  }

  /**
   * Method try to make a get request do siteFacadeSYDLE on site-sydle application
   */
  @Method()
  async sendRequestGet(path: string, body: any): Promise<any> {
    let url = this.apiUrl + 'com.sydle.growth.marketing/siteFacadeSYDLE/' + path;
    url += `?_body=${encodeURIComponent(JSON.stringify(body))}${this.acceptLanguage ? `&_lang=${this.acceptLanguage}` : ''}`;
    const token = this.getBearerToken();

    if (url.length < 2000) {
      return fetch(url, {
        cache: 'force-cache',
        headers: {
          'accept': 'application/json',
          'content-type': 'application/json',
          ...(token && { authorization: token }),
          ...(this.acceptLanguage && { 'accept-language': this.acceptLanguage }),
        },
        method: 'GET',
      })
        .then(response => response.json())
        .catch(e => console.log(e));
    } else {
      return this.sendRequest(path, body);
    }
  }

  /**
   * Method to get a portal's i18n config
   * TODO: Obter configuração do Site da SYDLE e não do Portal do Blog
   * @param portalId
   */
  @Method()
  async getSiteI18nConfig(portalId: string): Promise<SiteI18nConfig> {
    return this.sendRequestGet('getSiteI18nConfig', {
      portalId: portalId,
    });
  }

  /**
   * Method to get site's language package
   * @param language
   */
  @Method()
  async getTranslationBundle(language: string): Promise<any> {
    return this.sendRequestGet('getTranslationBundle', { language });
  }

  /**
   * Method to get user language based on country ip
   */
  @Method()
  async getCountryLanguage(): Promise<any> {
    return this.sendRequest('getCountryLanguage', { headers: null });
  }

  /**
   * Method to create a quiz answer
   */
  @Method()
  async createQuizAnswer(quizObj: string): Promise<any> {
    return this.sendRequest(
      'quizAnswer',
      {
        _id: quizObj,
      },
      'quizApi',
    );
  }

  /**
   *
   * Method to load quiz info
   */
  @Method()
  async loadQuizData(quizObj: string): Promise<any> {
    return this.sendRequest(
      'getQuiz',
      {
        _id: quizObj,
      },
      'quizApi',
    );
  }

  /**
   *
   * Method to answer a quiz question
   */
  @Method()
  async answerQuizQuestion(quizAnswerObj: string, answerIndex: number, questionIndex: number): Promise<any> {
    return this.sendRequest(
      'answerQuestion',
      {
        _id: quizAnswerObj,
        answerIndex: answerIndex,
        questionIndex: questionIndex,
      },
      'quizApi',
    );
  }

  /**
   *
   * Method to submit a quiz answer
   */
  @Method()
  async submitQuizAnswer(quizAnswerObj: string): Promise<any> {
    return this.sendRequest(
      'answerSubmit',
      {
        _id: quizAnswerObj,
      },
      'quizApi',
    );
  }
    /*
   * Method to get site's menu configuration
   * @param language
   */
  @Method()
  async getMenuConfig(): Promise<any> {
    await this.waitForLanguage;
    return this.sendRequestGet('getMenuConfigs', {});
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
